export default __webpack_public_path__ + "static/media/biancacperes.af05fb11.jpg";